import React from 'react';
import { Modal } from 'antd';
import './updateTipModal.less';

interface prpsJson {
  updateTipModalShow: boolean;
  modalUpdate: (val: boolean) => void;
}

function ConnectModal(prop: prpsJson) {
  const { updateTipModalShow, modalUpdate } = prop;

  return (
    <Modal
      wrapClassName="login-update-tip-modal-box"
      visible={updateTipModalShow}
      width={420}
      zIndex={999999999}
      maskClosable={true}
      centered
      footer={null}
      onCancel={() => modalUpdate(false)}
      closeIcon={<span className="operation_close"></span>}
    >
      <div className="login_header_box">
        <div className="login-update-tip-modal-box_box">
          <div className="login-update-tip-modal-box_title">发现新版本</div>
        </div>
        <div className="login-update-tip-modal-box_content">
          <p className="login-update-tip-modal-box_hint">
            检测到客户端有新版本。由于当前您的硬盘处于高负荷运行状态，直接更新可能会因读写缓慢导致更新失败。 <br />
            建议您先关闭或暂停其他占用硬盘的程序（如下载、渲染、大型游戏等）后再更新；您也可以选择跳过本次提醒，稍后再试。
            <br />
            <span
              onClick={() => {
                (window as any).raw.openExternalBrower({ url: 'https://docs.qq.com/doc/DTFFvYVJ3TGpTaHdz' });
              }}
            >
              查看教程
            </span>
          </p>
          <div className="login-update-tip-modal-box_footer">
            <div
              className="cancel"
              onClick={() => {
                modalUpdate(false);
              }}
            >
              跳过，暂不更新
            </div>
            <div
              className="confim"
              onClick={() => {
                modalUpdate(true);
              }}
            >
              继续更新
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ConnectModal;
